module.exports = __webpack_public_path__ + "img/_0.29dfd11c.png";